export enum UserAccess {
  Annual = 'annual',
  Pro = 'pro',
}

export const VIEW_ALL = 'View all';

export const MY_TI_COMPONENT_LIST = {
  [UserAccess.Annual]: [
    'ReadingStats',
    'Nav',
    'RecommendedArticles',
    'Topics',
    'Reporters',
    'Newsletters',
    'CommunityInsights',
  ],
  [UserAccess.Pro]: [
    'ReadingStats',
    'Nav',
    'DeepResearch',
    'OrgCharts',
    'DataTools',
    'RecommendedArticles',
    'Topics',
    'Reporters',
    'Newsletters',
    'CommunityInsights',
  ],
};
